<template>
  <section class="container-fluid">
    <CRow>
      <CCol sm="12">
        <CCard>
          <CCardHeader>
            <strong>Cambia tu contraseña</strong>
          </CCardHeader>
          <CCardBody>
            <ValidationObserver ref="form" v-slot="{ invalid }">
              <form @submit.prevent="edit">
                <section class="row">
                  <div class="col-6">
                    <div class="form-group required">
                      <ValidationProvider
                        name="password_current"
                        rules="required|min:6|max:60|currentPassword"
                        vid="password_current"
                        :debounce="500"
                        v-slot="{ valid, errors }"
                      >
                        <label class="control-label" for="password_current"
                          >Contraseña actual</label
                        >
                        <input
                          type="password"
                          v-model="user.password_current"
                          class="form-control form-control-sm"
                          id="password_current"
                        />
                        <b-form-invalid-feedback :state="valid">{{
                          errors[0]
                        }}</b-form-invalid-feedback>
                      </ValidationProvider>
                    </div>
                  </div>
                </section>

                <section class="row">
                  <div class="col-6">
                    <div class="form-group required">
                      <ValidationProvider
                        name="password_new"
                        rules="required|min:6|max:60"
                        vid="password_new"
                        v-slot="{ valid, errors }"
                      >
                        <label class="control-label" for="password_new"
                          >Nueva contraseña</label
                        >
                        <input
                          type="password"
                          v-model="user.password_new"
                          class="form-control form-control-sm"
                          id="password_new"
                        />
                        <b-form-invalid-feedback :state="valid">{{
                          errors[0]
                        }}</b-form-invalid-feedback>
                      </ValidationProvider>
                    </div>
                  </div>

                  <div class="col-6">
                    <div class="form-group required">
                      <ValidationProvider
                        name="password_confirm"
                        rules="required|min:6|max:60|password:@password_new"
                        v-slot="{ valid, errors }"
                      >
                        <label class="control-label" for="password_confirm"
                          >Confirmar contraseña</label
                        >
                        <input
                          type="password"
                          class="form-control form-control-sm"
                          id="confirm"
                          v-model="user.password_confirm"
                        />
                        <b-form-invalid-feedback :state="valid">{{
                          errors[0]
                        }}</b-form-invalid-feedback>
                      </ValidationProvider>
                    </div>
                  </div>
                </section>

                <button
                  class="card-header-action btn btn-sm btn-danger"
                  type="button"
                  @click="cancel"
                >
                  <CIcon size="sm" name="cil-x-circle" /> Cancelar
                </button>

                <button
                  type="submit"
                  class="btn btn-success btn-sm float-right"
                  variant="success"
                  :disabled="invalid || editLoader"
                >
                  <span v-if="!editLoader">Editar</span>
                  <span v-if="editLoader">
                    Cambiar
                    <CSpinner color="success" size="sm" />
                  </span>
                </button>
              </form>
            </ValidationObserver>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </section>
</template>
<script>
import { BFormInvalidFeedback } from "bootstrap-vue";
import { extend } from "vee-validate";
import { required, confirmed, max, min } from "vee-validate/dist/rules";
import Users from "../../plugins/services/users";

export default {
  name: "UserChangeOfPassword",
  components: { BFormInvalidFeedback },
  data() {
    return {
      user: {
        password_current: "",
        password_new: "",
        password_confirm: "",
      },
      editLoader: false,
    };
  },
  computed: {
    computedForm() {
      return this.$refs.form;
    },
    userAuth() {
      return this.$store.state.userAuth;
    },
  },
  watch: {
    userAuth: function (user) {
      if (user.id) {
        this.getUser(user.id);
      }
    },
  },
  created() {
    if (this.userAuth.id) {
      this.getUser(this.userAuth.id);
    }
    extend("required", {
      ...required,
      message: "Este campo es requerido.",
    });

    extend("max", {
      ...max,
      params: ["length"],
      message: "El campo debe tener {length} caracteres como máximo.",
    });

    extend("min", {
      ...min,
      params: ["length"],
      message: "El campo debe tener {length} caracteres como mínimo.",
    });

    extend("password", {
      params: ["target"],
      validate(value, { target }) {
        return value === target;
      },
      message: "Las contraseñas no coinciden.",
    });

    extend("currentPassword", {
      validate: this.isCurrentPassword,
      message: "La contraseña que ingresaste es incorrecta.'",
    });
  },
  mounted() {},
  methods: {
    edit() {
      var id = this.userAuth.id;
      this.editLoader = true;
      this.user.modified_by = this.userAuth.username;
      Users.changePassword(id, this.user)
        .then((res) => {
          this.editLoader = false;
          if ("errors" in res) {
            if ("name" in res.errors) {
              this.$refs.form.setErrors({
                name: res.errors.name[0],
              });
            }
          } else if (res.data.success) {
            this.$router.push("/dashboard");
            this.setShowAlert("success", res.data.message);
          }
        })
        .catch((err) => {
          this.editLoader = false;
          console.log(err);
          this.setShowAlert("danger", err.data.data);
        });
    },
    setShowAlert(variant, message) {
      this.$store.commit("setAlertValues", {
        variant: variant,
        message: message,
      });
    },
    getUser(id) {
      Users.getOne(id)
        .then((res) => {
          this.user = res.data;
          this.email_current = this.user.person.email;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async isCurrentPassword() {
      return Users.currentPassword(this.user)
        .then((res) => {
          if (res.data.data == true) {
            return false;
          } else {
            return true;
          }
        })
        .catch((err) => {
          return true;
        });
    },
    cancel() {
      this.$router.go(-1);
    },
  },
};
</script>
